// Enabled addons, in boot order.
//
// This file is YOURS and is the ONLY file `appfactory add <name>` edits. Each
// addon default-exports one object:
//
//   { id, boot(app)?, settingsRow()?, routes?, csp?, deepLinks? }
//
// The chassis iterates this array — calling boot, offering settingsRow to your
// settings sheet — and `appfactory config` derives CSP and deep links from the
// same list, so enabling an addon never means patching the chassis.
//
// Removing an addon is deleting its two lines.

export default [];
